// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1Zz5X","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__JW_gg"};